"use client";

import Script from "next/script";
import { VENUE_PAGE_PLATFORM_META_PIXEL_IDS } from "../../analyticsLoader/platformPixels";
import { buildPlatformMetaPixelSnippet } from "../../analyticsLoader/snippets";

const PlatformMetaPixelScript: React.FC = () => (
  <Script
    id="meta-pixel-platform"
    strategy="afterInteractive"
    dangerouslySetInnerHTML={{
      __html: buildPlatformMetaPixelSnippet(VENUE_PAGE_PLATFORM_META_PIXEL_IDS),
    }}
  />
);

export default PlatformMetaPixelScript;
